export function formatCnpj(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 14);
  if (digits.length !== 14) return '';
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

export async function persistCompanyCnpj(companyId, cnpj, identityService) {
  const formatted = formatCnpj(cnpj);
  if (!companyId || !formatted) return;
  await identityService.updateCompany(companyId, { cnpj: formatted });
}
